import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "@components/icons";
import StatusButton from "./Button/StatusButton";
import { statusList } from "@helper/healthState";

function filterTrees({ filterTerm, trees }) {
  if (!filterTerm) {
    return trees;
  }
  return trees.filter(
    (item) => item.name && item.name.toLowerCase()?.includes(filterTerm.toLowerCase())
  );
}

function getTreeStatusLabel(tree, t) {
  if (tree.health_state === 3) {
    if (!tree.has_active_sensor) return t("health_states.no_sensor");
    const ss = Number(tree.active_sensor_state);
    if (ss === 1 || ss === 2) return t("health_states.maintenance_needed");
    return t("health_states.no_data");
  }
  const entry = statusList.find((item) => item.key === tree.health_state);
  return entry ? t(entry.value) : "";
}

function TreeListMobileView({ trees }) {
  const { t } = useTranslation();
  const { pid } = useParams();
  const [filterTerm, setFilterTerm] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");

  const areaOptions = Array.from(
    new Map(
      (trees || [])
        .map((tree) => {
          const id = String(tree.area_id || tree?.area?.id || "");
          const name = tree.area_name || tree?.area?.name || "";
          if (!id || !name) return null;
          return [id, { id, name }];
        })
        .filter(Boolean)
    ).values()
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredTrees = filterTrees({ filterTerm, trees }).filter((tree) => {
    if (!selectedAreaId) return true;
    return String(tree.area_id || tree?.area?.id || "") === String(selectedAreaId);
  });

  function updateFilterHandler(event) {
    setFilterTerm(event.target.value);
  }

  return (
    <>
      <SearchForm>
        <input
          type="text"
          onChange={updateFilterHandler}
          className="form-control "
          placeholder={t("search_tree")}
          style={{
            padding: "12px 1em 12px 2em",
            color: "var(--color-text-primary, #0e1d2c)",
            backgroundColor: "var(--color-bg-surface, #ffffff)",
            borderColor: "var(--color-border-default, #cdd7df)",
          }}
        />
        <SearchIcon top={0} width="30px" />
      </SearchForm>
      {areaOptions.length > 0 && (
        <div className="mt-2">
          <select
            className="form-select"
            value={selectedAreaId}
            onChange={(event) => setSelectedAreaId(event.target.value)}
            style={{
              color: "var(--color-text-primary, #0e1d2c)",
              backgroundColor: "var(--color-bg-surface, #ffffff)",
              borderColor: "var(--color-border-default, #cdd7df)",
            }}
          >
            <option value="">{t("all_areas")}</option>
            {areaOptions.map((area) => (
              <option key={area.id} value={area.id}>
                {area.name}
              </option>
            ))}
          </select>
        </div>
      )}
      <div role="mobileList">
        {filteredTrees
          ?.sort((a, b) => (a.id < b.id ? 1 : -1))
          ?.map((tree) => {
            const primary = tree.tree_cadastre_no || tree.name;
            const secondary =
              tree.tree_cadastre_no && tree.name !== tree.tree_cadastre_no
                ? tree.name
                : tree.species_name || (tree.species ? tree.species.name : "");
            return (
              <MobileTreeLink
                to={
                  pid
                    ? `/project/${pid}/list/tree/${tree.id}/?selectedTree=${tree.id}`
                    : `/trees?selectedTree=${tree.id}`
                }
                key={tree.id}
                className="list-unstyled py-2 d-flex justify-content-between"
              >
                <div className="w-50" style={{ minWidth: 0 }}>
                  <h6 className="mb-1" style={{ color: "inherit" }}>
                    <b>{primary}</b>
                  </h6>
                  {secondary && <SecondaryText>{secondary}</SecondaryText>}
                </div>
                <div>
                  <StatusButton status={tree?.health_state} padding=" 2px 5px">
                    {getTreeStatusLabel(tree, t)}
                  </StatusButton>
                </div>
              </MobileTreeLink>
            );
          })}
      </div>
    </>
  );
}

export default TreeListMobileView;

const SearchForm = styled.div`
  position: relative;
`;

const MobileTreeLink = styled(Link)`
  color: var(--color-text-primary, #0e1d2c);
  text-decoration: none;

  &:visited,
  &:active,
  &:focus {
    color: var(--color-text-primary, #0e1d2c);
    text-decoration: none;
  }
`;

const SecondaryText = styled.i`
  color: var(--color-text-secondary, #3d5a6b);
`;
